import { ValidationRulesInterface } from "../types/types";

export const ROUTES = {
  // Основные
  MAIN: "/",
  PROMO: "/promo",
  FAVORITES: "/favorites",
  PROMO_ITEM: "/promo",
  PROFILE: "/profile",
  CONTACTS: "/contacts",
  ABOUT: "/about",
  CONTACTS_ITEM: "/contacts",
  ITEM: "/item",
  GROUP: "/group",
  ORDERS: "/orders",
  ORDER_DETAILS: "/orders",
  ADDRESSES: "/addresses",
  BONUS: "/bonus",
  BONUS_HISTORY: "/bonus/history",
  DELIVERY: "/delivery",
  CATEGORY: "/category",

  // Комплексные заявки
  COMPLEX_ORDERS: "/complex-orders",
  COMPLEX_ORDER_DETAILS: "/complex-orders",

  // 👇 ПЛАТЕЖИ
  PAYMENT_METHODS: "/payment-methods",
  PAYMENT: "/payment",

  // Аутентификация
  TELEGRAM_LOGIN: "/login",
  MAX_LOGIN: "/max_login",
  EMAIL_LOGIN: "/email_login",

  // Документы (модалки)
  PRIVACY_POLICY: "/privacy",
  USER_AGREEMENT: "/agreement",
  PERSONAL_DATA_AGREEMENT: "/personal-data",
  COOKIE_POLICY: "/cookie-policy",
} as const;

export const russiaCenter = { latitude: 66.25, longitude: 94.15 };
export const weekDaysEn = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
export const weekDaysRu = ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"];

export const serviceCodeValidations: ValidationRulesInterface[] = [
  {
    fieldName: "code",
    minLength: 6,
    maxLength: 6,
    format: /^\d{6}$/,
    canBeEmpty: false,
    isEmptyMessage: "Введите код",
    toShortMessage: "Код должен содержать 6 цифр",
    tooLongMessage: "Код должен содержать 6 цифр",
    formatMessage: "Только цифры",
  },
];
